import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import styles from "./customdropdownbar.module.css";

const CustomDropdownBar = ({ dropdownData, handleNavigation, currentActiveSubItem }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleItemClick = (path, title, e) => {
    e.preventDefault();
    const titlePathMap = {
      "By Integrations": `/Integration/${path}`,
      "By Functions": `functions/${path}`,
      "By Workflows": "/workflows",
      "By Systems": `/Integration/${path}`,
    };
    const navigationPath = titlePathMap[title] || path;

    if (navigationPath) {
      navigate(navigationPath);
    }
  };

  // Check if current item is active based on URL
  const isItemActive = (path) => {
    const currentPath = location.pathname;
    return currentPath.includes(path) || 
           currentPath === path ||
           (path.startsWith('/') && currentPath === path) ||
           currentActiveSubItem === path;
  };

  return (
    <div className={styles.dropdownContainer}>
      {dropdownData.map((section, index) => (
        <div key={index} className={styles.section}>
          <p
            onClick={(e) => handleItemClick(section.path, section.title, e)}
            className={`${styles.dropdownItem} ${
              isItemActive(section.path) ? styles.activeSubItem : ""
            }`}
          >
            {section.title}
          </p>
        </div>
      ))}
    </div>
  );
};

export default CustomDropdownBar;